













import { Vue, Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { Routes } from '@/router/routes'

@Component
export default class PriceConfigTableHeader extends Vue {
  @Prop(String)
  title: string

  routes = Routes
}
